import { useState } from 'react';
import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import { EyeButton, Input } from 'global/CustomInput/styled';

const PasswordInput = ({ error = '', onChange, value, ...rest }) => {
  const [type, setType] = useState('password');
  return (
    <>
      <Input
        type={type}
        className={error ? 'error' : ''}
        onChange={onChange}
        value={value}
        autoFocus
        autoComplete="off"
        suffix={
          <EyeButton
            type="button"
            onClick={() => setType(type === 'text' ? 'password' : 'text')}
            data-cy="custom-input-password-eye-toggle"
          >
            <Image
              src={type === 'password' ? '/icon/eye-off.svg' : '/icon/eye.svg'}
              alt=""
            />
          </EyeButton>
        }
        {...rest}
      />
      <Flex
        align="center"
        // @ts-expect-error
        pt="5px"
        style={{ visibility: error ? 'visible' : 'hidden' }}
        data-cy="new-password-error-validation"
      >
        <Iconmoon
          size="16px"
          className="icon-toolbar_error"
          color={color.sunsetOrange}
        />
        {/* @ts-expect-error */}
        <Text color={color.sunsetOrange} size="12px" weight="400px" pl="5px">
          {error}
        </Text>
      </Flex>
    </>
  );
};

export default PasswordInput;
